import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow, Section, YouAreHereDot } from './Section';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
import { tomes } from '../data/tomes';
import { bonuses } from '../data/bonuses';
const badges = ['Paiement unique', 'Accès immédiat', 'PDF à conserver et à imprimer'];
export function Pricing() {
  return <Section id="offre" tone="paper" labelledBy="prix-title" data-id="element-163" data-mp="1vtictcyyx7jm">
      <Eyebrow data-id="element-164" data-mp="1vw4l5etonr2w">L’offre</Eyebrow>
      <h2 id="prix-title" className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.75rem]" data-id="element-165" data-mp="1rsyei62nrxvw">
        Le système complet, dès aujourd’hui
      </h2>

      <div className="mt-14 border border-graphite bg-creme shadow-paper" data-id="element-166" data-mp="20sv90obqbqyv">
        <div className="grid grid-cols-1 lg:grid-cols-12" data-id="element-167" data-mp="3h7egcm2lmmlw">
          <div className="border-b border-warm-line p-8 md:p-12 lg:col-span-7 lg:border-b-0 lg:border-r" data-id="element-168" data-mp="3h5jr4vkao8c0">
            <h3 className="font-serif text-2xl font-semibold leading-snug text-graphite md:text-3xl" data-id="element-169" data-mp="3c81oto0s8rcz">
              {offer.name} — Édition complète
            </h3>
            <p className="mt-4 max-w-prose text-base leading-relaxed text-graphite-mid" data-id="element-170" data-mp="4s4bvc8hatif">
              Tout ce qu’il faut pour mener un accompagnement de la Séance Zéro
              au bilan de clôture, dans un cadre adapté à la France.
            </p>

            <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2" data-id="element-171" data-mp="3d8z31ufwypgo">
              <div data-id="element-172" data-mp="3dasahbycpdpq">
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-warm" data-id="element-173" data-mp="3d74jajgdp3e6">
                  Les 6 tomes
                </p>
                <ul className="mt-4 space-y-3" data-id="element-174" data-mp="3n63r5ztbkv04">
                  {tomes.map(tome => <li key={tome.number} className="flex gap-3 text-sm leading-relaxed text-graphite" data-id="element-175" data-mp="3ry3kvaisqro9">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-graphite-mid" aria-hidden="true" data-id="element-176" data-mp="2zhkivka9si81" />
                      <span data-id="element-177" data-mp="2reryxyyzyiu8">
                        Tome {Number(tome.number)} — {tome.title}
                        {tome.decisive && <span className="ml-1 text-rouge" aria-hidden="true" data-id="element-178" data-mp="3177lzap5hxlz">
                            ★
                          </span>}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div data-id="element-179" data-mp="23ixier9pv1sr">
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-warm" data-id="element-180" data-mp="23jpb9ubxilfc">
                  Bonus inclus
                </p>
                <ul className="mt-4 space-y-3" data-id="element-181" data-mp="2ihhrkopavdul">
                  {bonuses.map(bonus => <li key={bonus.number} className="flex gap-3 text-sm leading-relaxed text-graphite" data-id="element-182" data-mp="2dfsbuvr4uc06">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-graphite-mid" aria-hidden="true" data-id="element-183" data-mp="3ov7980n975vt" />
                      <span data-id="element-184" data-mp="59zy6zuzn9rt">{bonus.title}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-between gap-10 p-8 md:p-12 lg:col-span-5" data-id="element-185" data-mp="3nh69ae2i5pil">
            <div data-id="element-186" data-mp="3rirerecpj1ir">
              <div className="flex items-start gap-3" data-id="element-187" data-mp="j0va6l0sa6zm">
                <YouAreHereDot className="mt-2" data-id="element-188" data-mp="j26cegekz6om" />
                <p className="text-sm leading-relaxed text-graphite-mid" data-id="element-189" data-mp="nzydo114855h">
                  En France, une séance de coaching de particulier se facture le
                  plus souvent entre 50 et 150 €.
                </p>
              </div>

              <p className="mt-8 font-serif text-5xl font-semibold leading-none text-graphite md:text-6xl" data-id="element-190" data-mp="e8u0n6v02uda">
                {offer.price} €
              </p>
              <p className="mt-3 text-sm text-warm" data-id="element-191" data-mp="16q7htgggq6zt">
                TTC · le système complet
              </p>

              <ul className="mt-8 space-y-2 border-t border-warm-line pt-6 text-sm text-graphite-mid" data-id="element-192" data-mp="3f81t4xx6f8pe">
                {badges.map(badge => <li key={badge} data-id="element-193" data-mp="3a74bqnjzqioy">{badge}</li>)}
              </ul>
            </div>

            <div data-id="element-194" data-mp="359maljc7t7ri">
              <CtaButton href={offer.checkoutUrl} className="w-full" data-id="element-195" data-mp="35b5q37q1res8">
                Oui, je veux Le Système Complet du Coach
              </CtaButton>
              <p className="mt-5 text-xs leading-relaxed text-warm" data-id="element-196" data-mp="1rato4a0gz5s">
                Paiement sécurisé · Accès immédiat · Garantie de{' '}
                {offer.guaranteeDays} jours
              </p>
            </div>
          </div>
        </div>
      </div>

      <p className="mt-8 max-w-3xl text-xs leading-relaxed text-warm" data-id="element-197" data-mp="3k6li7772h0lz">
        Mention affichée au moment du paiement, avec case à cocher obligatoire :
        « Je demande l’accès immédiat au contenu numérique et je reconnais
        renoncer à mon droit de rétractation (article L221-28 du Code de la
        consommation). Cette renonciation ne modifie pas la garantie de
        satisfaction de {offer.guaranteeDays} jours. »
      </p>
    </Section>;
}